
































































import {Component, Prop, Watch} from 'vue-property-decorator';
import {Client, Medicine, Prescription} from "@/core/services/MedicaPro/models";
import {Api} from "@/core/services/MedicaPro/Api";
import {BaseList} from "@/core/components/BaseList";
import bus from "@/main";

@Component({
    components: {}
})
export default class ClientDetailsPagePrescriptionListView extends BaseList {

    // Bindings to parent
    @Prop() client!: Client;

    // Bindings to view
    public modelName = 'prescription';
    public items: Prescription[] = [];
    public headers = [
        {text: 'Medicin', value: 'medicine', sortable: false},
        {text: 'Varighed (dage)', value: 'duration', sortable: false},
        {text: 'Dosis', value: 'dosage', sortable: false},
        {text: 'Daglig dosis', value: 'daily-dosage', sortable: false},
        {text: '', value: 'actions', sortable: false},
    ];

    public created() {
        super.created();
    }

    public mounted() {
        super.mounted();
    }

    protected getItems(doItems = true, doCount = false) {
        // Get options from DataTable
        const options: any = this.options;

        // Mark as Loading
        this.loading = true;

        // Prepare API call
        const api = Api.prescriptions().get()
            .include('medicine')
            .where('client_id', this.client.id!);

        if (doItems) {
            api
                .limit(options.itemsPerPage)
                .offset(options.itemsPerPage * (options.page - 1))
                .orderDesc('medicine.name')
                .find(items => {
                    this.items = items;
                    this.loading = false;
                });
        }

        // Count total amount of items
        if (doCount) {
            api.count(count => {
                this.totalItems = count;
            });
        }
    }

    public createItem() {
        bus.$emit(`prescriptionEdit`, Prescription.Create(this.client));
    }

    public editItem(item: Prescription) {
        bus.$emit(`prescriptionEdit`, item);
    }

    public deleteItem(item: Prescription) {
        this.$confirm(`Er du sikker på, at du vil slette "${item.medicine?.name}"?`).then(res => {
            if (res) {
                Api.prescriptions().deleteById(item.id!).delete(item => {
                    this.getItems(true, true);
                });
            }
        });
    }

}
